import axios from 'axios';
import { apiConfig } from '../config/api';
import config from '../config/environment';
import Cookies from 'js-cookie';

const axiosInstance = axios.create(apiConfig);

// Helper to clear all auth cookies
const clearAuthCookies = () => {
  Cookies.remove('artote_token');
  Cookies.remove('artote_user_id');
  Cookies.remove('artote_user_name');
  Cookies.remove('artote_user_email');
  Cookies.remove('artote_user_mobile');
  Cookies.remove('artote_user_avatar');
  Cookies.remove('artote_user_isLoggedIn');
};

// Request interceptor
axiosInstance.interceptors.request.use(
  (requestConfig) => {
    // Get token from cookie
    const token = Cookies.get('artote_token');
    
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    
    if (config.debug) {
      console.log('📤 API Request:', requestConfig.method.toUpperCase(), requestConfig.url);
    }
    
    return requestConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if (config.debug) {
      console.log('📥 API Response:', response.status, response.config.url);
    }
    return response;
  },
  (error) => {
    if (config.debug) {
      console.error('❌ API Error:', {
        url: error.config?.url,
        status: error.response?.status,
        message: error.message,
        data: error.response?.data
      });
    }
    
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      // Clear all auth cookies
      clearAuthCookies();
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login-register')) {
        window.location.href = '/login-register';
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
